import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SEARCH_FEATURE, SearchState, StateWithSearch } from '../search-state';

export const getCustomSearchState: MemoizedSelector<StateWithSearch, SearchState> =
  createFeatureSelector<SearchState>(SEARCH_FEATURE);
